import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const emo = {
  state: {
    emos: {
      /*
        uuid:
        name:
        description:
        site_uuid:
        owner_uuid:
        owner_type:
        emo_category:
        saving_accuracy:
        saving_method:
        saving_pcn:
        energy_change:
        energy_unit:
        created_at:
        updated_at:
      */
    },
    site_emos: {

    }
  },
  mutations: {
    insertEmo(state, new_emo) {
      state.emos[new_emo.uuid] = new_emo;
    },

    insertSiteEmo(state, args) {
      if (state.site_emos[args.siteUUID]) {
        state.site_emos[args.siteUUID].push(args.emoUUID);
      } else {
        state.site_emos[args.siteUUID] = [ args.emoUUID ];
      }
    },

    updateEmo(state, payload) {
      const emoUUID = payload.uuid;
      if (state.emos[emoUUID]) {
        state.emos[emoUUID] = payload;
      }
    },

    removeEmo(state, emo_uuid) {
      const emo = state.emos[emo_uuid];
      if (emo) {
        const site_uuid = emo.site_uuid
        delete state.emos[emo_uuid];
        state.site_emos[site_uuid] = state.site_emos[site_uuid].filter(function(aUUID) {
          return aUUID !== emo_uuid;
        });

        if (isBlank(state.site_emos[site_uuid])) {
          delete state.site_emos[site_uuid]
        }        
      }
    },

    removeSiteEmos(state, site_uuid) {
      const emo_uuids = state.site_emos[site_uuid];
      emo_uuids.forEach(function(emo_uuid) {
        delete state.emos[emo_uuid];
      });
      delete state.site_emos[site_uuid];
    },

    removeAllEmos(state) {
      state.emos = {};
      state.site_emos = {};
    }
  },
  actions: {
    addEmo({ commit }, payload) {
      console.log("Inside emo.mondule.js, addEmo(), payload ==> ", payload);
      let new_emo = payload;

      if (!new_emo.uuid) {
        const new_uuid = uuidv4();
        new_emo.uuid = new_uuid;
        console.log("Inside emo.mondule.js, addEmo(), new_uuid ==> ", new_uuid);
        new_emo.created_at = new Date().toISOString();
        new_emo.updated_at = new Date().toISOString();  
      }
      commit("insertEmo", new_emo);
      commit("insertSiteEmo", { siteUUID: new_emo.site_uuid, emoUUID: new_emo.uuid });
      return new_emo.uuid;
    },

    modifyEmo({ commit }, payload) {
      let emo = payload;
      emo.updated_at = new Date().toISOString();
      commit("updateEmo", emo);
    },

    timestampEmoSync({ commit, getters }, emo_uuid) {
      const emo = getters.getEmoByUUID(emo_uuid);
      emo.sync_on = new Date().toISOString();
      commit("updateEmo", emo);
    },

    deleteEmo({ commit, dispatch }, emo_uuid) {
      dispatch('deleteNotesByOwner', emo_uuid);
      dispatch('deleteImagesByOwner', emo_uuid);
      commit("removeEmo", emo_uuid);
    },

    deleteEmosByOwner({ getters, dispatch }, owner_uuid) {
      const all_emos = getters.allEmosByOwner(owner_uuid);
      all_emos.forEach(function(emo) {
        dispatch('deleteEmo', emo.uuid);
      })
    },    

    clearAllEmos({ commit }) {
      commit("removeAllEmos");
    }
  },
  getters: {
    allEmos(state) {
      return state.emos
    },

    allSiteEmos(state) {
      return state.site_emos
    },

    getEmoByUUID(state) {
      return function(uuid) {
        const emo = state.emos[uuid];
        return emo ? deepClone(emo) : null;
      }
    },

    getEMOsBySiteUUID(state, getters) {
      return function(siteUUID) {
        const emoUUIDs = state.site_emos[siteUUID];
        if (emoUUIDs) {
          return emoUUIDs.map(function(emoUUID) {
            return getters.getEmoByUUID(emoUUID);
          });
        } else {
          return []
        }
      }
    },

    getEmoByName(state) {
      return function(giveName) {
        const emo = Object.values(state.emos).find(function(emo) {
          return (emo.name == giveName)
        });
        return emo ? deepClone(emo) : null;
      }
    },

    nbEmosBySite() {
      return function(ownerUUID) {
        return this.getEMOsBySiteUUID(ownerUUID).length
      }
    },

    allEmosByOwner(state) {
      return function(owner_uuid) {
        return Object.values(state.emos).filter(function(emo) {
          return emo.owner_uuid == owner_uuid;
        })
      }
    },      

    searchEmosBy(state, getters) {
      return function(args) {
        let emos = (args.site_id) ? getters.getEMOsBySiteUUID(args.site_id) : state.emos;
        if (args.asset_id) {
          emos = emos.filter(function(emo) {
            return emo.owner_uuid == args.asset_id;
          })
        }
        if (args.location_id) {
          emos = emos.filter(function(emo) {
            return emo.owner_uuid == args.location_id;
          })
        }
        return emos;
      }
    },

/*
    withEmoNameLike(state) {
      return function(args) {
        //const siteEmos = state.site_emos[args.siteUUID]
        const patt = new RegExp(name + " \\d");
        const emos = Object.values(state.emos).filter(function(emo) {
          return patt.test(args.emoName);
        });
        return emos;
      }
    }
    
    nameForEmo(state) {
      return function(site) {
        const emos = this.withEmoNameLike({name: emoName, siteUUID: site.uuid});
        if (emos.length == 0) {
          return emoSubType.name + " 1";
        } else {
          const lastSeqNo = emos.reduce(function(largestSoFar, emo) {
            const seqNo = parseInt(emo.name.replace(/\D/g, ''));
            if (!isNaN(seqNo)) {
              if (seqNo > largestSoFar) {
                return seqNo
              } else {
                return largestSoFar
              }
            } else {
              return largestSoFar
            }
          }, 0);
          return emoSubType.name + " " + (lastSeqNo + 1).toString();
        }
      }

    }
*/

  }
}